import EDFError from './edf.error';

export default class UnknownError extends EDFError {
    constructor(message: string, cause?: Error) {
        super(message, 'EDF:UnknownError', cause);
    }
}
